import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import type { MailOutboxItem } from "@/lib/notification.api";

const SOURCE_ROUTE: Record<string, (id: string) => string> = {
  invoices: (id) => `/invoices/${id}`,
  proformas: (id) => `/proformas/${id}`,
};

export function formatMailDateTime(value: string): string {
  return format(parseISO(value), "dd MMM yyyy HH:mm", { locale: fr });
}

export function humanizeTemplateKey(key: string): string {
  return key.replace(/_/g, " ").replace(/^./, (character) => character.toUpperCase());
}

export function getMailOutboxStatusTone(status: string): string {
  if (status === "sent") return "border-success-border bg-success-bg text-success-text";
  if (status === "failed") return "border-danger-border bg-danger-bg text-danger-text";
  return "border-warning-border bg-warning-bg text-warning-text";
}

export function getMailOutboxPageCount(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

export function getMailOutboxSourceLink(item: MailOutboxItem): { label: string; href?: string } {
  if (!item.sourceType || !item.sourceId) return { label: "-" };
  const label = `${item.sourceType} #${item.sourceId}`;
  const buildRoute = SOURCE_ROUTE[item.sourceType];
  return buildRoute ? { label, href: buildRoute(item.sourceId) } : { label };
}
